import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import {
	ICmmsFilterComponent,
	ICmmsFilterEmittedValue,
} from '@app/pages/cmms/components/cmms-sort-filters-grouping/cmms-applied-filters-bar/interfaces/filter-component.interface';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AuMatInputAutofocusDirective } from '../../../../../../shared/directives/au-mat-input-autofocus.directive';

import { NgxTolgeeModule } from '@tolgee/ngx';

const semicolonSeparatedValidator = (control: FormControl) => {
	const value = control.value.trim();
	let error = null;

	if (!value) {
		return null;
	}
	// check if value consists of single or multiple numbers where
	// each number is separated by semicolon and can have any amount of spaces
	// if it is only one number it can have no semicolon at the end
	// also the last number can have no semicolon at the end
	const regex = /^\d+(\s*;\s*\d+)*\s*;?\s*$/;

	if (!regex.test(value)) {
		error = { invalid: true };
	}

	// Return null if validation passes
	return error;
};

@Component({
	selector: 'multitext-filter',
	templateUrl: './multitext-filter.component.html',
	styleUrls: ['./multitext-filter.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatFormField,
		MatInput,
		ReactiveFormsModule,
		AuMatInputAutofocusDirective,
		MatError,
		NgxTolgeeModule,
	],
})
export class MultitextFilterComponent implements ICmmsFilterComponent, OnInit, OnDestroy {
	@Input() data: { preselectedValue?: string[]; columnName: string };
	@Output() filterValueChanged = new EventEmitter<ICmmsFilterEmittedValue>();

	searchControl = new FormControl<string>('', semicolonSeparatedValidator);

	private destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.searchControl.valueChanges
			.pipe(takeUntil(this.destroy$), distinctUntilChanged())
			.subscribe(searchValue => {
				// Input at load has pending state, so we need to mark it as touched
				// to run validation after first input instead of waiting to lose focus
				this.searchControl.markAsTouched();

				const isValidSearch = this.searchControl.valid;
				const label = isValidSearch ? searchValue : '';
				const data = isValidSearch
					? searchValue
							.trim()
							.split(';')
							.map(item => parseInt(item.trim(), 10))
							.filter(item => !isNaN(item))
					: [];

				this.filterValueChanged.emit({ columnName: this.data.columnName, label, data });
			});

		if (this.data?.preselectedValue) {
			setTimeout(() => {
				this.searchControl.setValue(this.data.preselectedValue.join(';'));
			});
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
